$(document).ready(function () {
    initOrderCreate();
    initOrderChildsCreate();
    initOrderUpdate();
    initOrdersImport();
    initOrdersList();
});

function initOrdersList() {
    let block = $('.orders-list');
    if (block.length === 0) {
        return;
    }

    block
        .on('click', '[data-action]', function () {
            let data = {
                ids: get_selected_orders(),
                action: $(this).data('action'),
                csrfmiddlewaretoken: $('input[name="csrfmiddlewaretoken"]').prop('value')
            };

            if (data.ids.length === 0) {
                showNoty('warning', gettext('Select order'));
                return;
            }

            if (data.action === 'update_placed_until') {
                confirmModal($(this), function () {
                    let modal = $('#confirmModal');
                    data['date_to'] = $('input[name="date_to"]', modal).val();

                    let url = '/orders/action/';
                    send_orders_action(url, data);
                }, function () {
                    let modal = $('#confirmModal');
                    $('.modal-extra', modal).append(
                        $('<div/>').addClass('input-group date mg-t-10').attr('id', 'datetimepicker_modal').append([
                            $('<input/>')
                                .addClass('form-control')
                                .attr('placeholder', gettext('Date'))
                                .attr('name', 'date_to'),
                            $('<span/>').addClass('input-group-append input-group-addon').append(
                                $('<i/>').addClass('input-group-text fas fa-calendar')
                            )
                        ])
                    );
                    $('#datetimepicker_modal', modal).datetimepicker({
                        locale: $('html').attr('lang'),
                        format: 'DD-MM-YYYY HH:mm'
                    });
                });
            } else {
                confirmModal($(this), function () {
                    let url = '/orders/action/';
                    send_orders_action(url, data);
                });
            }
        })
    ;
}

function send_orders_action(url, data) {
    $.ajax({
        type: 'POST',
        url: url,
        data: data,
        success: function (response) {
            location.reload(true);
        },
        error: function (response) {
            showNoty('error', response.responseJSON.message);
        }
    });
}

function get_selected_orders() {
    let ids = [];
    $('table tbody input[type="checkbox"]:checked').each(function () {
        ids.push($(this).val());
    });
    return ids;
}

function initOrderChildsCreate() {
    let block = $('.child-orders-create');
    if (block.length === 0) {
        return;
    }

    block
        .on('click', '[data-btn="rm"]', function () {
            $(this).closest('.child-order-item').remove();
            updateOrderChildCount();
            updateSelectedCells();
        })
        .on('click', '[data-btn="add"]', function () {
            let total = $('.child-order-item').length;
            let max = $('[name="child-order-MAX_NUM_FORMS"]').val();
            if (total >= max) {
                showNoty('error', gettext('Order limit'));
                return;
            }

            let data = {
                action: 'child_orders_new',
                device_uid: $('#id_device_uid').val(),
                total: total
            };
            let url = '/orders/create/ajax/';
            sendPost(url, data, function (response) {
                $('.child-order-items').append(response);
                initSelect2($('.child-order-item:last .select2'));
                updateOrderChildCount();
            });
        })
        .on('change', '.cell_type', function () {
            let item = $(this).closest('.child-order-item');
            let data = {
                action: 'cell_dimensions',
                device_uid: $('#id_device_uid').val(),
                order_status: $('#id_status').val(),
                order_type: $(this).val()
            };
            let url = '/orders/create/ajax/';
            sendPost(url, data, function (response) {
                let block = $('.cell_dimension', item);
                let values = response.data.cell_dimension;
                block.empty();
                values.forEach(function (value) {
//                    let available = $('.btn-info[data-dimension-id="' + value[0] + '"]:not(.btn-active-cell)').length;
//                    if (!available) {
//                        block.append($('<option disabled />').attr('value', value[0]).text(value[1]));
//                    } else {
                    block.append($('<option/>').attr('value', value[0]).text(value[1]));
//                    }
                });
                $('.cell_width, .cell_height, .cell_depth', item).val(null);
                updateSelectedCells();
            });
        })
        .on('change', '.cell_dimension', function () {
            let item = $(this).closest('.child-order-item');
            let dimension_id = $(this).val();

            let available = $('.btn-info[data-dimension-id="' + dimension_id + '"]:not(.btn-active-cell)').length;
            if (!available) {
                if (dimension_id) {
                    showNoty('error', gettext('No available cells'));
                }
                $('.cell_type', item).val(null).trigger('change.select2');
                $('.cell_dimension', item).val(null).trigger('change.select2');
                $('.cell_height', item).val(null);
                $('.cell_width', item).val(null);
                $('.cell_depth', item).val(null);
                updateSelectedCells();
                return;
            }

            let data = {
                action: 'cell_dimension',
                device_uid: $('#id_device_uid').val(),
                dimension_id: dimension_id
            };
            let url = '/orders/create/ajax/';
            sendPost(url, data, function (response) {
                $('.cell_height', item).val(response.data.height);
                $('.cell_width', item).val(response.data.width);
                $('.cell_depth', item).val(response.data.depth);
                $('.cell_type', item).val(response.data.cell_type).trigger('change.select2');
                updateSelectedCells();
            });
        })
    ;
}

function updateOrderChildCount() {
    $('[name="child-order-TOTAL_FORMS"]').val($('.child-order-item').length);
}

function updateSelectedCells() {
    $('.btn-info[data-dimension-id]').removeClass('btn-active-cell');
    $('.cell_dimension').each(function () {
        $('.btn-info[data-dimension-id="' + $(this).val() + '"]:not(.btn-active-cell)').first().addClass('btn-active-cell');
    });
}

function initOrderCreate() {
    let block = $('.order-create-form');
    if (block.length === 0) {
        return;
    }

    initSelect2();

    block
        .on('change', '#id_order_type_code, #id_create_type_code', function () {
            $(this).closest('form').submit();
        })
        .on('change', '#id_ref_order_uid', function () {
            let value = $(this).val();
            let orders = $(this).data('orders');
            let order_number = '';
            if (value && value in orders) {
                order_number = orders[value];
            }
            $('#id_order_number').val(order_number);
        })
        .on('change', '#id_status', function () {
            order_update_selects('devices');
            order_update_cell_dimension();
        })
        .on('change', '#id_device_region', function () {
            $('#id_device_address').val('');
            $('#id_device_uid').val('');
            order_update_selects('regions');
        })
        .on('change', '#id_device_address', function () {
            $('#id_device_uid').val('');
            order_update_selects('addresses');
        })
        .on('change', '#id_device_uid', function () {
            $('#id_cell_dimension').val('');
            order_update_selects('devices');
            order_update_cell_dimension();
        })
        .on('change', '#id_cell_dimension', function () {
            let data = {
                action: 'cell_dimension',
                device_uid: $('#id_device_uid').val(),
                dimension_id: $(this).val()
            };
            let url = '/orders/create/ajax/';
            sendPost(url, data, function (response) {
                $('#id_cell_width').val(response.data.width);
                $('#id_cell_height').val(response.data.height);
                $('#id_cell_depth').val(response.data.depth);
                updateSelectedCells();
            });
        })
    ;

    let device_uid = $('#id_device_uid').val();
    if (device_uid) {
        initOrderDevice(device_uid, true);
    }
}

function order_update_selects(type) {
    let data = {
        action: 'selects',
        region: $('#id_device_region').val(),
        address: $('#id_device_address').val(),
        device_uid: $('#id_device_uid').val(),
        order_type: $('#id_order_type_code').val()
    };
    let url = '/orders/create/ajax/';
    sendPost(url, data, function (response) {
        order_update_select('regions', response.data, type);
        order_update_select('addresses', response.data, type);
        order_update_select('devices', response.data, type);
    });
}

function order_update_cell_dimension(type) {
    let device_block = $('#id_device_uid');
    let cell_dimension_block = $('#id_cell_dimension');
    if (device_block.length === 0 || cell_dimension_block.length === 0) {
        return;
    }

    let data = {
        action: 'cell_dimensions',
        device_uid: device_block.val(),
        order_type: $('#id_order_type_code').val(),
        order_status: $('#id_status').val()
    };
    let url = '/orders/create/ajax/';
    sendPost(url, data, function (response) {
        order_update_select('cell_dimension', response.data, type);
    });
}

function order_update_select(type, data, update_type) {
    let block;
    let values = data[type];

    if (type === 'regions') {
        block = $('#id_device_region');
    } else if (type === 'addresses') {
        block = $('#id_device_address');
    } else if (type === 'devices') {
        block = $('#id_device_uid');
    } else if (type === 'cell_dimension') {
        block = $('#id_cell_dimension');
    }

    if (block.length === 0) {
        return;
    }

    let current_value = block.val();
    let last_value = null;
    block.empty();
    if (type === 'devices') {
        values.forEach(function (value) {
            last_value = value[0];
//            if (value[2] === true || value[2] === undefined) {
            block.append($('<option/>').attr('value', value[0]).text(value[1]));
//            } else {
//                block.append($('<option disabled="disabled"/>').attr('value', value[0]).text(value[1]));
//            }
        });
    } else {
        values.forEach(function (value) {
            last_value = value[0];
            block.append($('<option/>').attr('value', value[0]).text(value[1]));
        });
    }

    let set_value = false;
    if (values.length === 2 && last_value.length > 0 && type !== update_type) {
        set_value = true;
    } else if (current_value && current_value.length !== 0 && type === update_type) {
        set_value = true;
    }

    if (type === 'cell_dimension') {
        set_value = false;
    } else if (type === 'devices') {
        initOrderDevice(last_value, set_value);
        initOrderChildsForm(set_value ? last_value : null);
    }

    if (set_value) {
        block.val(last_value);
        if (type !== update_type && type === 'devices') {
            order_update_cell_dimension();
        }
    }
}

function initOrderDevice(device_uid, set_value) {
    if (set_value) {
        initOrderDeviceStacks(device_uid);
        $('#device-stacks').show();
        $('#device-status').show();

    } else {
        $('#device-stacks').hide();
        $('#device-status').hide();
    }
}

function initOrderChildsForm(device_uid) {
    let block = $('.child-orders-create');
    if (block.length === 0) {
        return;
    }

    let inner = $('.child-orders-inner');
    inner.empty();

    if (!device_uid) {
        return;
    }

    let data = {
        action: 'child_orders_init',
        device_uid: device_uid
    };
    let url = '/orders/create/ajax/';
    sendPost(url, data, function (response) {
        inner.append(response);
        initSelect2(inner.find('.select2'));
    });
}


function initOrderUpdate() {
    let block = $('.order-update-form');
    if (block.length === 0) {
        return;
    }

    let order_id = $('[data-order-id]').data('order-id');

    block
        .on('click', '[data-action]', function () {
            let data = {
                ids: [order_id],
                action: $(this).data('action'),
                csrfmiddlewaretoken: $('input[name="csrfmiddlewaretoken"]').prop('value')
            };

            if (data.action === 'update_placed_until') {
                confirmModal($(this), function () {
                    let modal = $('#confirmModal');
                    data['date_to'] = $('input[name="date_to"]', modal).val();

                    let url = '/orders/action/';
                    send_orders_action(url, data);
                }, function () {
                    let modal = $('#confirmModal');
                    $('.modal-extra', modal).append(
                        $('<div/>').addClass('input-group date mg-t-10').attr('id', 'datetimepicker_modal').append([
                            $('<input/>')
                                .addClass('form-control')
                                .attr('placeholder', gettext('Date'))
                                .attr('name', 'date_to'),
                            $('<span/>').addClass('input-group-append input-group-addon').append(
                                $('<i/>').addClass('input-group-text fas fa-calendar')
                            )
                        ])
                    );
                    $('#datetimepicker_modal', modal).datetimepicker({
                        locale: $('html').attr('lang'),
                        format: 'DD-MM-YYYY HH:mm'
                    });
                });
            } else {
                // confirmModal($(this), function () {
                //     let url = '/orders/action/';
                //     send_orders_action(url, data);
                // });
            }
        })
    ;
}

function initOrdersImport() {
    let block = $('.orders-import-form');
    if (block.length === 0) {
        return;
    }

    $('#orders-import-form')
        .on('submit', function (e) {
            e.preventDefault();

            let submited = $(this).get(0).submited;
            if ((submited === 'update' || submited === 'create') && !confirm(gettext('Are you sure?'))) {
                return false;
            }

            let formData = new FormData($(this).get(0));
            formData.append('submited', submited);

            let errors = $('#order-import-errors').empty();
            let results = $('#order-import-results').empty();
            let buttons = $('#order-import-buttons').empty();
            $.ajax({
                url: $(this).attr('action'),
                type: $(this).attr('method'),
                data: formData,
                cache: false,
                processData: false,
                contentType: false,
                success: function (data) {
                    if (data.status === 200) {
                        results.append(data.data.results);
                        buttons.append(data.data.buttons);
                    } else {
                        errors.append($('<div/>').addClass('alert alert-warning').text('✘ ' + data.message));
                    }
                }
            });
            return false;
        })
        .on('change', '[name="file"]', function () {
            let filename = $(this).val().split('\\').pop();
            if (filename === '') {
                filename = 'Choose file';
            }
            $(this).siblings('label').text(filename);
        })
    ;

}

function initOrderDeviceStacks(device_uid) {
    let data = {
        action: 'device_template',
        order_type: $('#id_order_type_code').val(),
        order_status: $('#id_status').val(),
        device_uid: device_uid // last_value is device uid
    };
    let url = '/orders/create/ajax/';
    sendPost(url, data, function (response) {
        render_device_stacks(response.data.device_info);
        render_device_pie(response.data.device_info);
        updateSelectedCells();
        updateDeviceMapView();
    });
}

function render_device_stacks(device) {
    // Render device stacks and cell on Order page
    // Similar to:
    // /frontend/templates/devices/panel/cell.html and /frontend/templates/devices/panel/stack.html

    let block = $('#render_device_stacks');
    block.empty();

    let stacks_html = "<div class='device-stack-container card-body' data-width='" + device.device_width / 2 + "'>";
    for (let stack in device.stacks) {
        stacks_html = stacks_html
            + "<div class='device-stack'><div class='device-stack-header'></div><div class='device-stack-body' style='width:"
            + device.stacks[stack]['width'] / 2 + "px;height:" + device.stacks[stack]['height'] / 2 + "px;'>";

        for (let col in device.stacks[stack]['cells']) {
            stacks_html = stacks_html
                + "<div class='device-stack-col' style='height:"
                + device.stacks[stack]['cells'][col][0][0].height_col / 2
                + "px;width:"
                + device.stacks[stack]['cells'][col][0][0].width_col / 2
                + "px;'>";

            for (let row in device.stacks[stack]['cells'][col]) {
                // <div class="device-stack-row" style="width:100%;height:{{ row.0.height_p }}%">
                stacks_html = stacks_html
                + "<div class='device-stack-row' style='height:"
                + device.stacks[stack]['cells'][col][row][0].height_p
                + "%;width:100%;'>";

                for (let cell in device.stacks[stack]['cells'][col][row]) {
                    stacks_html = stacks_html
                        + "<button type='button' class='btn btn-sm btn-icon "
                        + device.stacks[stack]['cells'][col][row][cell].btn
                        + " device-stack-cell ";

                    if (device.stacks[stack]['cells'][col][row][cell].width_p < 40) {
                        stacks_html = stacks_html + "device-stack-cell-sm";
                    }

                    stacks_html = stacks_html + "'"
                        + "data-cell='"
                        + device.stacks[stack]['cells'][col][row][cell].key
                        + "' "
                        + "data-cell-code='"
                        + device.stacks[stack]['cells'][col][row][cell].code
                        + "' "
                        + "data-cell-controller='"
                        + device.stacks[stack]['cells'][col][row][cell].stack
                        + "'"
                        + "data-cell-uid='"
                        + device.stacks[stack]['cells'][col][row][cell].uid
                        + "'"
                        + "data-dimension-id='"
                        + device.stacks[stack]['cells'][col][row][cell].dimension_id
                        + "'"
                        + "style='width: "
                        + device.stacks[stack]['cells'][col][row][cell].width_p
                        + "%;' title='"
                        + device.stacks[stack]['cells'][col][row][cell].cell
                        + ":"
                        + device.stacks[stack]['cells'][col][row][cell].stack + " " + device.stacks[stack]['cells'][col][row][cell].type
                        + "'><span class='device-stack-cell-id'></span>"
                        + "<span class='device-stack-cell-ico row'>";

                    // Render icons
                    // for (let icon in device.stacks[stack]['cells'][col][row][cell]['icons']) {
                    //     stacks_html = stacks_html
                    //     + "<i class='btn-micro btn-dark p-1 fas "
                    //     + device.stacks[stack]['cells'][col][row][cell]['icons'][icon]
                    //     + "' data-toggle='tooltip' "
                    //     if (device.stacks[stack]['cells'][col][row][cell].parcel && device.stacks[stack]['cells'][col][row][cell]['icons'][icon].includes('box')) {
                    //         stacks_html = stacks_html
                    //         + "title='"
                    //         + device.stacks[stack]['cells'][col][row][cell].parcel
                    //         + "'"
                    //     }
                    //     stacks_html = stacks_html + "></i>"
                    // }

                    stacks_html = stacks_html + "</span></button>";
                }

                stacks_html = stacks_html + "</div>";
            }  // for (let row in device.stacks[stack]['cells'][col])
            stacks_html = stacks_html + "</div>";
        } //for (let col in device.stacks[stack]['cells'])

        stacks_html = stacks_html + "</div></div>";
    } //for (let stack in device.stacks)
    stacks_html = stacks_html + "</div>";

    block.append(stacks_html);
}

function render_device_pie(info) {
    let block = $('[data-dashboard="device-load-pie"]');
    if (block.length === 0) {
        return;
    }

    let unavailable_cells = info.locked_cells + info.occupied_cells;
    let series = [{
        colorByPoint: false,
        data: [{
            name: _('Occupied'),
            count: unavailable_cells,
            y: parseFloat(((unavailable_cells / info.cells_number) * 100).toFixed(2)),
            color: '#e5e9f2'
        }, {
            name: _('Free'),
            count: info.free_cells,
            y: parseFloat(((info.free_cells / info.cells_number) * 100).toFixed(2)),
            color: '#45aaf2'
        }]
    }];

    Highcharts.chart('device-load-pie', {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
        },
        title: null,
        tooltip: {
            pointFormat: '<b>{point.count}</b> ({point.percentage:.1f}%)'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle',
            itemMarginTop: 3,
            itemMarginBottom: 3
        },
        plotOptions: {
            pie: {
                cursor: 'pointer',
                dataLabels: {
                    enabled: false
                },
                showInLegend: true
            }
        },
        series: series
    });
}
